
import { useState } from 'react';
import Header from '../home/components/Header';
import TabBar from '../home/components/TabBar';

export default function RealEstate() {
  const [activeTab, setActiveTab] = useState('home');
  const [selectedSubcategory, setSelectedSubcategory] = useState<number | null>(null);
  const [selectedTransactionType, setSelectedTransactionType] = useState<string | null>(null);

  const transactionTypes = [
    { id: 'sale', name: 'للبيع', icon: 'ri-price-tag-3-line', color: 'bg-green-500' },
    { id: 'rent', name: 'للإيجار', icon: 'ri-calendar-line', color: 'bg-blue-500' },
    { id: 'wanted', name: 'مطلوب', icon: 'ri-search-line', color: 'bg-orange-500' },
    { id: 'exchange', name: 'للبدل', icon: 'ri-exchange-line', color: 'bg-purple-500' }
  ];

  const subcategories = [
    { id: 21, name: 'الأراضي', count: '18 مزاد', icon: 'ri-landscape-line' },
    { id: 22, name: 'العزب', count: '7 مزاد', icon: 'ri-home-4-line' },
    { id: 23, name: 'المزارع', count: '11 مزاد', icon: 'ri-plant-line' },
    { id: 24, name: 'الفلل السكنية', count: '15 مزاد', icon: 'ri-home-3-line' },
    { id: 25, name: 'الفلل الخدمية', count: '8 مزاد', icon: 'ri-building-2-line' },
    { id: 26, name: 'الشقق السكنية', count: '12 مزاد', icon: 'ri-building-line' },
    { id: 27, name: 'البيوت الشعبية', count: '9 مزاد', icon: 'ri-home-2-line' },
    { id: 28, name: 'عقارات أخرى', count: '5 مزاد', icon: 'ri-home-line' },
    { id: 29, name: 'العمارات', count: '8 مزاد', icon: 'ri-building-4-line' },
    { id: 30, name: 'الأبراج', count: '5 مزاد', icon: 'ri-skyscraper-line' }
  ];

  const realEstateAuctions = [
    {
      id: 1,
      title: 'فيلا فاخرة في الخليج الغربي',
      location: 'الخليج الغربي، الدوحة',
      area: '800 متر مربع',
      bedrooms: 5,
      bathrooms: 6,
      currentBid: '2,500,000',
      image: 'https://public.readdy.ai/ai/img_res/294691f2c9bc310ee10df1b51f983a12.jpg',
      bidders: 8,
      category: 'الفلل السكنية',
      transactionType: 'sale',
      timeLeft: { hours: 2, minutes: 45, seconds: 30 }
    },
    {
      id: 2,
      title: 'أرض تجارية في الخليج الشرقي',
      location: 'الخليج الشرقي، الدوحة',
      area: '1200 متر مربع',
      currentBid: '1,800,000',
      image: 'https://readdy.ai/api/search-image?query=Commercial%20land%20plot%20with%20city%20skyline%20view%2C%20urban%20development%20area%2C%20professional%20real%20estate%20photography%2C%20modern%20city%20planning%2C%20investment%20opportunity%2C%20Qatar%20commercial%20district%2C%20clear%20boundaries&width=300&height=200&seq=land1&orientation=landscape',
      bidders: 12,
      category: 'الأراضي',
      transactionType: 'sale',
      timeLeft: { hours: 1, minutes: 20, seconds: 15 }
    },
    {
      id: 3,
      title: 'شقة فاخرة للإيجار في برج الخليج',
      location: 'الخليج التجاري، الدوحة',
      area: '180 متر مربع',
      bedrooms: 3,
      bathrooms: 3,
      currentBid: '8,500',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20apartment%20interior%20with%20modern%20design%2C%20premium%20finishes%2C%20elegant%20living%20space%2C%20high-end%20residential%20property%2C%20professional%20interior%20photography%2C%20sophisticated%20lighting%2C%20contemporary%20furniture%2C%20Qatar%20luxury%20living&width=300&height=200&seq=apt1&orientation=landscape',
      bidders: 15,
      category: 'الشقق السكنية',
      transactionType: 'rent',
      timeLeft: { hours: 4, minutes: 10, seconds: 45 }
    },
    {
      id: 4,
      title: 'مزرعة في الخور',
      location: 'الخور، قطر',
      area: '5000 متر مربع',
      currentBid: '1,200,000',
      image: 'https://readdy.ai/api/search-image?query=Agricultural%20farm%20land%20with%20green%20fields%20and%20palm%20trees%2C%20rural%20Qatar%20landscape%2C%20farming%20property%2C%20professional%20real%20estate%20photography%2C%20natural%20environment%2C%20investment%20opportunity%2C%20agricultural%20development&width=300&height=200&seq=farm1&orientation=landscape',
      bidders: 6,
      category: 'المزارع',
      transactionType: 'sale',
      timeLeft: { hours: 6, minutes: 30, seconds: 20 }
    },
    {
      id: 5,
      title: 'مطلوب عمارة سكنية في الريان',
      location: 'الريان، قطر',
      area: '600 متر مربع',
      floors: 4,
      units: 8,
      currentBid: '3,200,000',
      image: 'https://readdy.ai/api/search-image?query=Modern%20residential%20building%20exterior%2C%20multi-story%20apartment%20complex%2C%20contemporary%20architecture%2C%20professional%20real%20estate%20photography%2C%20Qatar%20residential%20development%2C%20elegant%20facade%20design%2C%20urban%20living&width=300&height=200&seq=building1&orientation=landscape',
      bidders: 10,
      category: 'العمارات',
      transactionType: 'wanted',
      timeLeft: { hours: 3, minutes: 15, seconds: 55 }
    },
    {
      id: 6,
      title: 'برج تجاري للبدل',
      location: 'الخليج الغربي، الدوحة',
      area: '2000 متر مربع',
      floors: 15,
      currentBid: '8,500,000',
      image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20tower%20building%2C%20high-rise%20architecture%2C%20business%20district%2C%20professional%20real%20estate%20photography%2C%20Qatar%20skyline%2C%20contemporary%20office%20building%2C%20glass%20facade%2C%20urban%20development&width=300&height=200&seq=tower1&orientation=landscape',
      bidders: 5,
      category: 'الأبراج',
      transactionType: 'exchange',
      timeLeft: { hours: 8, minutes: 45, seconds: 10 }
    }
  ];

  const filteredAuctions = realEstateAuctions.filter(auction => {
    const matchesSubcategory = selectedSubcategory 
      ? auction.category === subcategories.find(sub => sub.id === selectedSubcategory)?.name
      : true;
    
    const matchesTransactionType = selectedTransactionType 
      ? auction.transactionType === selectedTransactionType
      : true;
    
    return matchesSubcategory && matchesTransactionType;
  });

  const getTransactionTypeLabel = (type: string) => {
    const transactionType = transactionTypes.find(t => t.id === type);
    return transactionType ? transactionType.name : '';
  };

  const getTransactionTypeColor = (type: string) => {
    const transactionType = transactionTypes.find(t => t.id === type);
    return transactionType ? transactionType.color : 'bg-gray-500';
  };

  return (
    <div className="min-h-screen bg-black text-white" style={{ fontFamily: 'Cairo, sans-serif' }}>
      <Header />
      
      <main className="pt-16 pb-20">
        <div className="px-4 py-6">
          <div className="flex items-center mb-6">
            <button 
              onClick={() => window.history.back()}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-900 ml-3"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            <div>
              <h1 className="text-xl font-bold">العقارات</h1>
              <p className="text-sm text-gray-400">78 مزاد متاح</p>
            </div>
          </div>

          {/* Transaction Types Filter */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4">نوع المعاملة</h3>
            <div className="flex overflow-x-auto pb-2 space-x-3 space-x-reverse">
              <button
                onClick={() => setSelectedTransactionType(null)}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedTransactionType === null 
                    ? 'bg-yellow-400 text-black' 
                    : 'bg-gray-900 text-white hover:bg-gray-800'
                }`}
              >
                الكل
              </button>
              {transactionTypes.map((type) => (
                <button
                  key={type.id}
                  onClick={() => setSelectedTransactionType(type.id)}
                  className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center ${
                    selectedTransactionType === type.id 
                      ? 'bg-yellow-400 text-black' 
                      : 'bg-gray-900 text-white hover:bg-gray-800'
                  }`}
                >
                  <i className={`${type.icon} ml-1`}></i>
                  {type.name}
                </button>
              ))}
            </div>
          </div>

          {/* Subcategories Filter */}
          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-4">أنواع العقارات</h3>
            <div className="flex overflow-x-auto pb-2 space-x-3 space-x-reverse">
              <button
                onClick={() => setSelectedSubcategory(null)}
                className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedSubcategory === null 
                    ? 'bg-yellow-400 text-black' 
                    : 'bg-gray-900 text-white hover:bg-gray-800'
                }`}
              >
                الكل
              </button>
              {subcategories.map((subcategory) => (
                <button
                  key={subcategory.id}
                  onClick={() => setSelectedSubcategory(subcategory.id)}
                  className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                    selectedSubcategory === subcategory.id 
                      ? 'bg-yellow-400 text-black' 
                      : 'bg-gray-900 text-white hover:bg-gray-800'
                  }`}
                >
                  {subcategory.name}
                </button>
              ))}
            </div>
          </div>

          {/* Subcategories Grid */}
          <div className="grid grid-cols-2 gap-4 mb-6">
            {subcategories.map((subcategory) => (
              <button
                key={subcategory.id}
                onClick={() => setSelectedSubcategory(subcategory.id)}
                className="bg-gray-900 rounded-xl p-4 text-center hover:bg-gray-800 transition-colors"
              >
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-yellow-400/10 rounded-lg">
                  <i className={`${subcategory.icon} text-2xl text-yellow-400`}></i>
                </div>
                <h4 className="font-medium text-sm mb-1">{subcategory.name}</h4>
                <p className="text-xs text-gray-400">{subcategory.count}</p>
              </button>
            ))}
          </div>

          {/* Real Estate Auctions */}
          <div className="mb-4">
            <h3 className="text-lg font-semibold mb-4">
              {selectedSubcategory || selectedTransactionType
                ? `مزادات ${selectedSubcategory ? subcategories.find(sub => sub.id === selectedSubcategory)?.name : 'العقارات'} ${selectedTransactionType ? getTransactionTypeLabel(selectedTransactionType) : ''}`
                : 'جميع مزادات العقارات'
              }
            </h3>
          </div>

          <div className="space-y-4">
            {filteredAuctions.map((auction) => (
              <div key={auction.id} className="bg-gray-900 rounded-xl overflow-hidden">
                <div className="relative">
                  <img 
                    src={auction.image}
                    alt={auction.title}
                    className="w-full h-48 object-cover object-top"
                  />
                  <div className="absolute top-3 right-3 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-medium flex items-center">
                    <div className="w-1.5 h-1.5 bg-white rounded-full ml-1 animate-pulse"></div>
                    مباشر
                  </div>
                  <div className="absolute top-3 left-3 flex space-x-2 space-x-reverse">
                    <div className="bg-black/70 text-white px-2 py-1 rounded-full text-xs">
                      {auction.category}
                    </div>
                    <div className={`${getTransactionTypeColor(auction.transactionType)} text-white px-2 py-1 rounded-full text-xs`}>
                      {getTransactionTypeLabel(auction.transactionType)}
                    </div>
                  </div>
                  <button className="absolute bottom-3 left-3 w-8 h-8 bg-black/70 rounded-full flex items-center justify-center">
                    <i className="ri-heart-line text-white"></i>
                  </button>
                </div>
                
                <div className="p-4">
                  <h4 className="font-semibold mb-2">{auction.title}</h4>
                  
                  <div className="flex items-center text-sm text-gray-400 mb-3">
                    <i className="ri-map-pin-line ml-1"></i>
                    <span>{auction.location}</span>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                    <div className="flex items-center">
                      <i className="ri-ruler-line text-yellow-400 ml-2"></i>
                      <span>{auction.area}</span>
                    </div>
                    {auction.bedrooms && (
                      <div className="flex items-center">
                        <i className="ri-hotel-bed-line text-yellow-400 ml-2"></i>
                        <span>{auction.bedrooms} غرف</span>
                      </div>
                    )}
                    {auction.bathrooms && (
                      <div className="flex items-center">
                        <i className="ri-drop-line text-yellow-400 ml-2"></i>
                        <span>{auction.bathrooms} حمام</span>
                      </div>
                    )}
                    {auction.floors && (
                      <div className="flex items-center">
                        <i className="ri-building-line text-yellow-400 ml-2"></i>
                        <span>{auction.floors} طوابق</span>
                      </div>
                    )}
                    {auction.units && (
                      <div className="flex items-center">
                        <i className="ri-home-line text-yellow-400 ml-2"></i>
                        <span>{auction.units} وحدة</span>
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <p className="text-xs text-gray-400 mb-1">
                        {auction.transactionType === 'rent' ? 'الإيجار الشهري' : 'السعر الحالي'}
                      </p>
                      <p className="text-lg font-bold text-yellow-400">
                        {auction.currentBid} ر.ق
                        {auction.transactionType === 'rent' && <span className="text-sm">/شهر</span>}
                      </p>
                    </div>
                    <div className="text-left">
                      <p className="text-xs text-gray-400 mb-1">الوقت المتبقي</p>
                      <div className="flex items-center space-x-1 space-x-reverse">
                        <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                          {auction.timeLeft.hours.toString().padStart(2, '0')}
                        </span>
                        <span className="text-xs">:</span>
                        <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                          {auction.timeLeft.minutes.toString().padStart(2, '0')}
                        </span>
                        <span className="text-xs">:</span>
                        <span className="bg-gray-800 px-2 py-1 rounded text-xs font-mono">
                          {auction.timeLeft.seconds.toString().padStart(2, '0')}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <i className="ri-user-line text-gray-400 ml-1"></i>
                      <span className="text-sm text-gray-400">{auction.bidders} مزايد</span>
                    </div>
                    <button className="bg-yellow-400 text-black px-6 py-2 rounded-full font-semibold text-sm">
                      {auction.transactionType === 'wanted' ? 'عرض' : 'زايد الآن'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      
      <TabBar activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}
